export default {"src":"/_next/static/media/dextools.95001372.svg","height":31,"width":100,"blurWidth":0,"blurHeight":0};